import { Link } from '../links/Link';
import { LinkedEntityBase } from '../links/LinkedEntityBase';

export class MenuIcon extends LinkedEntityBase {
  icono?: string;

  constructor(orden: number = 0, titulo?: string, enlace?: Link, mensaje?: string, icono?: string) {
    super(orden, titulo, enlace, mensaje);
    this.icono = icono;
  }
}